export type OnboardingCheckoutNavigationState = "settled" | "redirecting";

export const shouldReleaseOnboardingPlanLoading = (
  navigationState: OnboardingCheckoutNavigationState,
): boolean => navigationState !== "redirecting";
